import { all, takeEvery, takeLatest, put, call } from 'redux-saga/effects'
import { getIdiomas } from 'utiles/idiomas'
import {
  getVentasFromAggregator,
  getVentasFilterFromAggregator,
  getVentasFilterMensajerosNuestrosFromAggregator,
  getVentasFilterRescateFromAggregator,
  getVentasFilterPersonalizadosFromAggregator,
  getVentasFilterPersonalizadosTotalFromAggregator,
  getVentasFilterPersonalizadosPreparadosFromAggregator,
  getVentasFilterPersonalizadosFabricadosFromAggregator,
  getVentasFilterEnSobreFromAggregator,
  getVentasFilterNocturnosFromAggregator,
  getVentasFilterDiurnosFromAggregator,
  getVentasFilterEcommerceFromAggregator,
  getVentasFilterEcommerceTramoHorarioFromAggregator,
  getVentasFilterLocalAggregator,
  getVentasFilterDigitalAggregator,
  getVentasFilterEmpleadosAggregator,
  getVentasFilterEkomiAggregator,
  getVentasFilterFueraDeEspanaAggregator,
  getVentasFilterFueraDeEspanaSeurAggregator,
  getVentasFilterFueraDeEspanaDhlAggregator,
  getVentasFilterDhlAggregator,
  getObservacionesVenta,
  getAllMailObservacionesTemplateVenta,
  getVentaById,
  updateVenta,
  insertObservacionSeguimientoVenta,
  deleteAbonoVenta,
  deleteCuponVenta,
  getCuponesNoUsados,
  addCupones,
  cancelarVenta,
  insertObservacionPreparacionVenta,
  enviarMailObservacionVenta,
  borrarMensajero,
  borrarBandeja,
  marcarPagado,
  insertarNuevaDevolucion,
  anularDevolucion,
  setVentaLetra,
  setVentaVip,
  insertarNuevoAbono,
  getAbonosListByVentaId,
  traspasarVenta,
  dhlBuscar,
  dhl,
  cambiarEstadoMensajeria,
  updateDhls,
  transmitirDhls,
  seur,
  seurBuscar,
  updateSeurs,
  transmitirSeurs,
  correosExpressBuscar,
  correosExpressEcommerce,
  correosExpressEcommerceTramo,
  correosExpressSobres,
  transmitirCorreosExpress,
  updateCorreosExpress,
  mrwClickBuscar,
  mrwClickDiurnos,
  mrwClickNocturnos,
  mrwClickEcommerce,
  mrwClickEcommerceTh,
  mrwClickSobre,
  updateMrws,
  transmitirMrwsClick,
  insertObservacion,
  modificarObservacion,
  deleteObservacion,
  insertEstadoBulto,
  modificarEstadobulto,
  deleteEstadoBulto,
  getEstadosBultos,
  getBandejasTodas,
  vaciarBandejaTodas,
  getBandejas,
  getBandejasLog,
  getBandejaById,
  getEstanterias,
  modificarEstanteria,
  deleteEstanteria,
  getEstantesLlenos,
  getCodigoBarrasEstanteria,
  getVentasFilterChocomensajeMasivoAggregator,
  getVentasFilterNocturnosCorreosAggregator,
  terminarBandeja,
  getEstanteriaVenta,
  setVentaBandeja,
  getCorreosExpress,
  removeVentaEstante,
  setObservacionesBulto,
  setVentaFinalizarImprimir,
  getOrdenEstanteria,
  setOrdenEstanteria,
  getEstanteAleatorio,
  setVentaItemSeparado,
  setVentaEstanteria,
  setObservacionCierreVenta,
  setVentaItemVerificado,
  getVentasAgrupadas,
  setBandejaPropuesta,
  getModificacionesVenta,
  getVentasFilterAmazonFromAggregator,
  setBultosCheckBulto,
  setEstadoVenta,
  setEstadoBultoVenta,
  setEstadoVentaMasivo,
  setEstadoMensajeriaVentaMasivo,
  getPedidosMensajeros,
  setOrdenMensajeroVentas,
  setDatosEntregaVenta,
  setTransportistaVenta,
  deleteTransportistaVenta,
  setMensajeroSeparado,
  insertMailObservaciones,
  updateMailObservaciones,
  deleteMailObservaciones,
  getAmazonFilter,
  setAmazonTransmitir,
  getVentasFilterGrabadosSinPersoFromAggregator,
  getVentasFilterBordadosSinPersoFromAggregator,
  getVentasFilterFigurasLegoFromAggregator,
  getVentasFilterTodosFromAggregator,
  getVentaByIdControlDiseno,
  getVentasTildarFilterFromAggregator,
} from 'services/ventas'
import { ventaModificarAdmin, ventaStatus } from 'utiles/venta'
import { actions } from './actions'
import { putMessage, messageType, putDialog } from '../../utiles/mensaje'

function showVentasFilterError(e) {
  if (e?.httpStatus === 504) putMessage(messageType.WARNING, 'Tiempo de espera agotado. Por favor, inténtalo de nuevo.')
  else putMessage(messageType.ERROR, 'Error al cargar ventas')
}

export function* GET_VENTAS() {
  try {
    const ventasData = yield call(getVentasFromAggregator)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      yield put({
        type: actions.VENTAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* RESET_VENTA() {
  try {
    yield put({
      type: actions.RESET_VENTA_LOAD_SUCCEEDED,
    })
  } catch (e) {
    yield all([
      put({
        type: actions.RESET_VENTA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTA_BY_ID(action) {
  try {
    const ventaData = yield call(getVentaById, action.payload)
    if (ventaData.ok) {
      if (!ventaData.data) putMessage(messageType.INFO, 'Venta no encontrada')
      yield put({
        type: actions.VENTA_BYID_LOAD_SUCCEEDED,
        payload: ventaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la venta')
      put({
        type: actions.VENTA_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTA_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTA_BYID_CONTROLDISENO(action) {
  try {
    const ventaData = yield call(getVentaByIdControlDiseno, action.payload)
    if (ventaData.ok) {
      if (!ventaData.data) putMessage(messageType.INFO, 'Venta no encontrada')
      yield put({
        type: actions.VENTA_BYID_CONTROLDISENO_LOAD_SUCCEEDED,
        payload: ventaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la venta')
      put({
        type: actions.VENTA_BYID_CONTROLDISENO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTA_BYID_CONTROLDISENO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_VENTA(action) {
  try {
    const ventaObj = yield call(updateVenta, action.payload)
    if (ventaObj.data?.result === ventaModificarAdmin.VentaNoUltimaVersion) {
      putMessage(messageType.ERROR, 'Otro usuario ya actualizó esta Venta')
      yield put({
        type: actions.VENTA_UPDATE_FILED,
      })
      // El timestamp en el store quedo desactualizado (por eso choco). Recargamos en
      // background para que el proximo intento de modificar use uno fresco sin que el
      // usuario tenga que refrescar la pagina a mano.
      yield put({
        type: actions.VENTA_BYID_LOAD_REQUESTED,
        payload: action.payload.ventaId,
        background: true,
      })
      return
    }
    if (ventaObj.ok) {
      putMessage(messageType.SUCCESS, 'Venta modificada correctamente')
      action.payload.timestamp = ventaObj.data.timestamp
      action.payload.envio = ventaObj.data.envio
      action.payload.aduana = ventaObj.data.aduana
      action.payload.aereo = ventaObj.data.aereo
      yield put({
        type: actions.VENTA_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
      // El backend recalcula importes (envio, suplemento, descuento, total, etc.)
      // que no vienen en la respuesta del PUT; recargamos la venta completa.
      yield put({
        type: actions.VENTA_BYID_LOAD_REQUESTED,
        payload: action.payload.ventaId,
        background: true,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Venta')
      yield put({
        type: actions.VENTA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Venta')
    yield all([
      put({
        type: actions.VENTA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER(action) {
  try {
    const ventasData = yield call(getVentasFilterFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      yield put({
        type: actions.VENTAS_FILTER_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_TILDAR_FILTER(action) {
  try {
    const ventasData = yield call(getVentasTildarFilterFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      yield put({
        type: actions.VENTAS_TILDAR_FILTER_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_TILDAR_FILTER_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* VENTAS_RELOAD_VENTA(payload) {
  try {
    const ventasData = yield call(getVentasFilterFromAggregator, { ventaId: payload.id })
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_RELOAD_VENTA_SUCCEEDED,
        payload: ventasData.data[0],
      })
    } else {
      putMessage(messageType.ERROR, 'Error al recargar venta')
      yield all([
        put({
          type: actions.VENTAS_RELOAD_VENTA_FILED,
          error: 'Error al recargar venta',
        }),
      ])
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_RELOAD_VENTA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_MENSAJEROS_NUESTROS(action) {
  try {
    const ventasData = yield call(getVentasFilterMensajerosNuestrosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_GRABADOS_SIN_PERSO_NUESTROS(action) {
  try {
    const ventasData = yield call(getVentasFilterGrabadosSinPersoFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_BORDADOS_SIN_PERSO_NUESTROS(action) {
  try {
    const ventasData = yield call(getVentasFilterBordadosSinPersoFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_RESCATE(action) {
  try {
    const ventasData = yield call(getVentasFilterRescateFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_RESCATE_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_RESCATE_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_RESCATE_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_PERSONALIZADOS(action) {
  try {
    const ventasData = yield call(getVentasFilterPersonalizadosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_PERSONALIZADOS_TOTAL(action) {
  try {
    const ventasData = yield call(getVentasFilterPersonalizadosTotalFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_PERSONALIZADOS_PREPARADOS(action) {
  try {
    const ventasData = yield call(
      getVentasFilterPersonalizadosPreparadosFromAggregator,
      action.payload,
    )
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_PERSONALIZADOS_FABRICADOS(action) {
  try {
    const ventasData = yield call(
      getVentasFilterPersonalizadosFabricadosFromAggregator,
      action.payload,
    )
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_EN_SOBRE(action) {
  try {
    const ventasData = yield call(getVentasFilterEnSobreFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_EN_SOBRE_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_EN_SOBRE_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_EN_SOBRE_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_TODOS(action) {
  try {
    const ventasData = yield call(getVentasFilterTodosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_TODOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_TODOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_TODOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_NOCTURNOS(action) {
  try {
    const ventasData = yield call(getVentasFilterNocturnosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_NOCTURNOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_NOCTURNOS_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_NOCTURNOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_DIURNOS(action) {
  try {
    const ventasData = yield call(getVentasFilterDiurnosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_DIURNOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_DIURNOS_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_DIURNOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_FIGURAS_LEGO(action) {
  try {
    const ventasData = yield call(getVentasFilterFigurasLegoFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_ECOMMERCE(action) {
  try {
    const ventasData = yield call(getVentasFilterEcommerceFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_ECOMMERCE_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_ECOMMERCE_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_ECOMMERCE_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO(action) {
  try {
    const ventasData = yield call(
      getVentasFilterEcommerceTramoHorarioFromAggregator,
      action.payload,
    )
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_LOCAL(action) {
  try {
    const ventasData = yield call(getVentasFilterLocalAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_LOCAL_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_LOCAL_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_LOCAL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_DIGITALES(action) {
  try {
    const ventasData = yield call(getVentasFilterDigitalAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_DIGITAL_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_DIGITAL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_DIGITAL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_EMPLEADOS(action) {
  try {
    const ventasData = yield call(getVentasFilterEmpleadosAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_EMPLEADOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_EMPLEADOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_EMPLEADOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_EKOMI(action) {
  try {
    const ventasData = yield call(getVentasFilterEkomiAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_EKOMI_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_EKOMI_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_EKOMI_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_FUERA_DE_ESPANA(action) {
  try {
    const ventasData = yield call(getVentasFilterFueraDeEspanaAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_FUERA_DE_ESPANA_SEUR(action) {
  try {
    const ventasData = yield call(getVentasFilterFueraDeEspanaSeurAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_FUERA_DE_ESPANA_DHL(action) {
  try {
    const ventasData = yield call(getVentasFilterFueraDeEspanaDhlAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_DHL(action) {
  try {
    const ventasData = yield call(getVentasFilterDhlAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_DHL_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_DHL_LOAD_FILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_DHL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_CHOCOMENSAJE(action) {
  try {
    const ventasData = yield call(getVentasFilterChocomensajeMasivoAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_NOCTURNOS_CORREOS(action) {
  try {
    const ventasData = yield call(getVentasFilterNocturnosCorreosAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_OBSERVACIONES_VENTAS(action) {
  try {
    const observacionesData = yield call(getObservacionesVenta, action.payload)
    if (observacionesData.ok) {
      yield put({
        type: actions.OBSERVACIONES_VENTA_LOAD_SUCCEEDED,
        payload: observacionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar observaciones ventas')
      put({
        type: actions.OBSERVACIONES_VENTA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.OBSERVACIONES_VENTA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS(action) {
  try {
    const observacionesData = yield call(getAllMailObservacionesTemplateVenta, action.payload)
    if (observacionesData.ok) {
      yield put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_SUCCEEDED,
        payload: observacionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar mail observaciones template venta')
      put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_MAIL_OBSERVACIONES(action) {
  try {
    const mailObservaciones = yield call(insertMailObservaciones, action.payload)
    if (mailObservaciones.ok) {
      putMessage(messageType.SUCCESS, 'Plantilla de Observaciones creada correctamente')
      yield put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_INSERT_SUCCEEDED,
        payload: mailObservaciones.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear la Plantilla de Observaciones')
      yield put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear la Plantilla de Observaciones')
    yield all([
      put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_MAIL_OBSERVACIONES(action) {
  try {
    const mailObservaciones = yield call(updateMailObservaciones, action.payload)
    if (mailObservaciones.ok) {
      putMessage(messageType.SUCCESS, 'Plantilla de Observaciones modificada correctamente')
      yield put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_SUCCEEDED,
        payload: mailObservaciones.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar la Plantilla de Observaciones')
      yield put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar la Plantilla de Observaciones')
    yield all([
      put({
        type: actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_MAIL_OBSERVACIONES(action) {
  try {
    const mailObservaciones = yield call(deleteMailObservaciones, action.payload)
    if (mailObservaciones.ok) {
      putMessage(messageType.SUCCESS, 'Plantilla de Observaciones eliminada correctamente')
      yield put({
        type: actions.DELETE_MAIL_OBSERVACION_TEMPLATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la Plantilla de Observaciones')
      put({
        type: actions.DELETE_MAIL_OBSERVACION_TEMPLATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la Plantilla de Observaciones')
    yield all([
      put({
        type: actions.DELETE_MAIL_OBSERVACION_TEMPLATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_OBSERVACION_SEGUIMIENTO_VENTA(action) {
  try {
    const observacionSeguimientoVentaObj = yield call(
      insertObservacionSeguimientoVenta,
      action.payload,
    )
    if (observacionSeguimientoVentaObj.ok) {
      putMessage(messageType.SUCCESS, 'Observacion Seguimiento Venta creado correctamente')
      yield put({
        type: actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_SUCCEEDED,
        payload: observacionSeguimientoVentaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Observacion Seguimiento Venta')
      yield put({
        type: actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Observacion Seguimiento Venta')
    yield all([
      put({
        type: actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ABONO_VENTA(action) {
  try {
    const abonoVentaObj = yield call(deleteAbonoVenta, action.payload)
    if (abonoVentaObj.ok) {
      putMessage(messageType.SUCCESS, 'Abono Venta borrado correctamente')
      yield put({
        type: actions.ABONO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar Abono Venta')
      yield put({
        type: actions.ABONO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar Abono Venta')
    yield all([
      put({
        type: actions.ABONO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CUPON_VENTA(action) {
  try {
    const cuponObj = yield call(deleteCuponVenta, action.payload)
    if (cuponObj.ok) {
      putMessage(messageType.SUCCESS, 'Cupón borrado correctamente')
      yield put({
        type: actions.CUPON_DELETE_SUCCEEDED,
        payload: action.payload.cuponId,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar Cupón')
      yield put({
        type: actions.CUPON_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar Cupón')
    yield all([
      put({
        type: actions.CUPON_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CUPONES_NO_USADOS() {
  try {
    const cuponesData = yield call(getCuponesNoUsados)
    if (cuponesData.ok) {
      yield put({
        type: actions.CUPONES_LOAD_SUCCEEDED,
        payload: cuponesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar cupones')
      put({
        type: actions.CUPONES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CUPONES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ADD_CUPONES_VENTA(action) {
  try {
    const cuponesObj = yield call(addCupones, action.payload)
    if (cuponesObj.ok) {
      putMessage(messageType.SUCCESS, 'Cupones añadidos correctamente')
      yield put({
        type: actions.ADD_CUPONES_SUCCEEDED,
        payload: action.payload.cuponesIdCuponesInsertar,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al añadir cupones')
      yield put({
        type: actions.ADD_CUPONES_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al añadir cupones')
    yield all([
      put({
        type: actions.ADD_CUPONES_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* CANCELAR_VENTA(action) {
  try {
    const cancelarVentaObj = yield call(cancelarVenta, action.payload)
    if (cancelarVentaObj.ok) {
      putMessage(messageType.SUCCESS, 'Venta Cancelada correctamente')
      cancelarVentaObj.data.status = ventaStatus.Cancelada
      yield put({
        type: actions.CANCELAR_VENTA_SUCCEEDED,
        payload: cancelarVentaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Cancelar Venta')
      yield put({
        type: actions.CANCELAR_VENTA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Cancelar Venta')
    yield all([
      put({
        type: actions.CANCELAR_VENTA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_OBSERVACION_PREPARACION_VENTA(action) {
  try {
    const observacionPreparacionVentaObj = yield call(
      insertObservacionPreparacionVenta,
      action.payload,
    )
    if (observacionPreparacionVentaObj.ok) {
      putMessage(messageType.SUCCESS, 'Observación Preparación Venta creado correctamente')
      yield put({
        type: actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_SUCCEEDED,
        payload: observacionPreparacionVentaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Observación Preparación Venta')
      yield put({
        type: actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Observación Preparación Venta')
    yield all([
      put({
        type: actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ENVIAR_MAIL_OBSERVACION_VENTA(action) {
  try {
    const enviarMailObservacionVentaObj = yield call(enviarMailObservacionVenta, action.payload)
    if (enviarMailObservacionVentaObj.ok) {
      putMessage(messageType.SUCCESS, 'Envío de mail creado correctamente')
      yield put({
        type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_SUCCEEDED,
        payload: enviarMailObservacionVentaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Envío de Mail')
      yield put({
        type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Envío de Mail')
    yield all([
      put({
        type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ENVIAR_MAIL_OBSERVACION_VENTA_DONE(action) {
  yield put({
    type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_SUCCEEDED,
    payload: action.payload,
  })
}

export function* BORRAR_MENSAJERO(action) {
  try {
    const borrarMensajeroObj = yield call(borrarMensajero, action.payload)
    if (borrarMensajeroObj.ok) {
      putMessage(messageType.SUCCESS, 'Mensajero Borrado correctamente')
      yield put({
        type: actions.BORRAR_MENSAJERO_SUCCEEDED,
        payload: borrarMensajeroObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Borrar Mensajero')
      yield put({
        type: actions.BORRAR_MENSAJERO_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Borrar Mensajero')
    yield all([
      put({
        type: actions.BORRAR_MENSAJERO_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* BORRAR_BANDEJA(action) {
  try {
    const borrarBandejaObj = yield call(borrarBandeja, action.payload)
    if (borrarBandejaObj.ok) {
      putMessage(messageType.SUCCESS, 'Bandeja Borrada correctamente')
      yield put({
        type: actions.BORRAR_BANDEJA_SUCCEEDED,
        payload: borrarBandejaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Borrar Bandeja')
      yield put({
        type: actions.BORRAR_BANDEJA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Borrar Bandeja')
    yield all([
      put({
        type: actions.BORRAR_BANDEJA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MARCAR_PAGADO(action) {
  try {
    const marcarPagadoObj = yield call(marcarPagado, action.payload)
    if (marcarPagadoObj.ok) {
      putMessage(messageType.SUCCESS, 'Pagado actualizado correctamente')
      yield put({
        type: actions.MARCAR_PAGADO_SUCCEEDED,
        payload: marcarPagadoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar Pagado')
      yield put({
        type: actions.MARCAR_PAGADO_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al actualizar Pagado')
    yield all([
      put({
        type: actions.MARCAR_PAGADO_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERTAR_NUEVA_DEVOLUCION(action) {
  try {
    const nuevaDevolucionObj = yield call(insertarNuevaDevolucion, action.payload)
    if (nuevaDevolucionObj.ok) {
      putMessage(messageType.SUCCESS, 'Devolución Creada correctamente')
      yield put({
        type: actions.INSERTAR_NUEVA_DEVOLUCION_SUCCEEDED,
        payload: nuevaDevolucionObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Crear Devolución')
      yield put({
        type: actions.INSERTAR_NUEVA_DEVOLUCION_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Crear Devolución')
    yield all([
      put({
        type: actions.INSERTAR_NUEVA_DEVOLUCION_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ANULAR_DEVOLUCION(action) {
  try {
    const anularDevolucionObj = yield call(anularDevolucion, action.payload)
    if (anularDevolucionObj.ok) {
      putMessage(messageType.SUCCESS, 'Devolución Anulada correctamente')
      yield put({
        type: actions.ANULAR_DEVOLUCION_SUCCEEDED,
        payload: anularDevolucionObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Anular Devolución')
      yield put({
        type: actions.ANULAR_DEVOLUCION_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Anular Devolución')
    yield all([
      put({
        type: actions.ANULAR_DEVOLUCION_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_LETRA(action) {
  try {
    const setVentaLetraObj = yield call(setVentaLetra, action.payload)
    if (setVentaLetraObj.ok) {
      putMessage(messageType.SUCCESS, 'Set Venta Letra correctamente')
      yield put({
        type: actions.SET_VENTA_LETRA_SUCCEEDED,
        payload: setVentaLetraObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Set Venta Letra')
      yield put({
        type: actions.SET_VENTA_LETRA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Set Venta Letra')
    yield all([
      put({
        type: actions.SET_VENTA_LETRA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_VIP(action) {
  try {
    const setVentaVipObj = yield call(setVentaVip, action.payload)
    if (setVentaVipObj.ok) {
      putMessage(messageType.SUCCESS, 'Set Venta Vip correctamente')
      yield put({
        type: actions.SET_VENTA_VIP_SUCCEEDED,
        payload: setVentaVipObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Set Venta Vip')
      yield put({
        type: actions.SET_VENTA_VIP_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Set Venta Vip')
    yield all([
      put({
        type: actions.SET_VENTA_VIP_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERTAR_NUEVO_ABONO(action) {
  try {
    const insertarNuevoAbonoObj = yield call(insertarNuevoAbono, action.payload)
    if (insertarNuevoAbonoObj.ok) {
      putMessage(messageType.SUCCESS, 'Abono insertado correctamente')
      const abonosList = yield call(getAbonosListByVentaId, action.payload.ventaId)
      const abonosListResult = { abonosList: abonosList.data }
      const result = { ...abonosListResult, ...insertarNuevoAbonoObj.data }
      yield put({
        type: actions.INSERT_ABONO_SUCCEEDED,
        payload: result,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al insertar Abono')
      yield put({
        type: actions.INSERT_ABONO_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al insertar Abono')
    yield all([
      put({
        type: actions.INSERT_ABONO_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRASPASAR_VENTA(action) {
  try {
    const traspasarventaObj = yield call(traspasarVenta, action.payload)
    if (traspasarventaObj.ok) {
      putMessage(messageType.SUCCESS, 'Venta Traspasada correctamente')
      yield put({
        type: actions.TRASPASAR_VENTA_SUCCEEDED,
        payload: traspasarventaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Traspasar Venta')
      yield put({
        type: actions.TRASPASAR_VENTA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Traspasar Venta')
    yield all([
      put({
        type: actions.TRASPASAR_VENTA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DHL_BUSCAR(action) {
  try {
    const dhlBuscarObj = yield call(dhlBuscar, action.payload)
    if (dhlBuscarObj.ok) {
      yield put({
        type: actions.DHL_BUSCAR_SUCCEEDED,
        payload: dhlBuscarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Dhl')
      yield put({
        type: actions.DHL_BUSCAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Dhl')
    yield all([
      put({
        type: actions.DHL_BUSCAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_BUSCAR(action) {
  try {
    const mrwClickBuscarObj = yield call(mrwClickBuscar, action.payload)
    if (mrwClickBuscarObj.ok) {
      yield put({
        type: actions.MRWCLICK_BUSCAR_SUCCEEDED,
        payload: mrwClickBuscarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_BUSCAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_BUSCAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_DIURNOS(action) {
  try {
    const mrwClickDiurnosObj = yield call(mrwClickDiurnos, action.payload)
    if (mrwClickDiurnosObj.ok) {
      yield put({
        type: actions.MRWCLICK_DIURNOS_SUCCEEDED,
        payload: mrwClickDiurnosObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_DIURNOS_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_DIURNOS_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_NOCTURNOS(action) {
  try {
    const mrwClickNocturnosObj = yield call(mrwClickNocturnos, action.payload)
    if (mrwClickNocturnosObj.ok) {
      yield put({
        type: actions.MRWCLICK_NOCTURNOS_SUCCEEDED,
        payload: mrwClickNocturnosObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_NOCTURNOS_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_NOCTURNOS_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_ECOMMERCE(action) {
  try {
    const mrwClickEcommerceObj = yield call(mrwClickEcommerce, action.payload)
    if (mrwClickEcommerceObj.ok) {
      yield put({
        type: actions.MRWCLICK_ECOMMERCE_SUCCEEDED,
        payload: mrwClickEcommerceObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_ECOMMERCE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_ECOMMERCE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_ECOMMERCE_TH(action) {
  try {
    const mrwClickEcommerceThObj = yield call(mrwClickEcommerceTh, action.payload)
    if (mrwClickEcommerceThObj.ok) {
      yield put({
        type: actions.MRWCLICK_ECOMMERCETH_SUCCEEDED,
        payload: mrwClickEcommerceThObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_ECOMMERCETH_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_ECOMMERCETH_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* MRWCLICK_SOBRE(action) {
  try {
    const mrwClickSobreObj = yield call(mrwClickSobre, action.payload)
    if (mrwClickSobreObj.ok) {
      yield put({
        type: actions.MRWCLICK_SOBRE_SUCCEEDED,
        payload: mrwClickSobreObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Mrw')
      yield put({
        type: actions.MRWCLICK_SOBRE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_SOBRE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DHL_DHL_BUSCAR(action) {
  try {
    const dhlObj = yield call(dhl, action.payload)
    if (dhlObj.ok) {
      yield put({
        type: actions.DHL_DHL_BUSCAR_SUCCEEDED,
        payload: dhlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Dhl')
      yield put({
        type: actions.DHL_DHL_BUSCAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Dhl')
    yield all([
      put({
        type: actions.DHL_DHL_BUSCAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* CORREOS_EXPRESS_BUSCAR(action) {
  try {
    const correosExpressBuscarObj = yield call(correosExpressBuscar, action.payload)
    if (correosExpressBuscarObj.ok) {
      yield put({
        type: actions.CORREOS_EXPRESS_BUSCAR_SUCCEEDED,
        payload: correosExpressBuscarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_BUSCAR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_BUSCAR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* CORREOS_EXPRESS_ECOMMERCE(action) {
  try {
    const correosExpressEcommerceObj = yield call(correosExpressEcommerce, action.payload)
    if (correosExpressEcommerceObj.ok) {
      yield put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_SUCCEEDED,
        payload: correosExpressEcommerceObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* CORREOS_EXPRESS_ECOMMERCE_TRAMO(action) {
  try {
    const correosExpressEcommerceTramoObj = yield call(correosExpressEcommerceTramo, action.payload)
    if (correosExpressEcommerceTramoObj.ok) {
      yield put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_SUCCEEDED,
        payload: correosExpressEcommerceTramoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* CORREOS_EXPRESS_SOBRES(action) {
  try {
    const correosExpressSobresObj = yield call(correosExpressSobres, action.payload)
    if (correosExpressSobresObj.ok) {
      yield put({
        type: actions.CORREOS_EXPRESS_SOBRES_SUCCEEDED,
        payload: correosExpressSobresObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_SOBRES_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_SOBRES_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SEUR_BUSCAR(action) {
  try {
    const seurBuscarObj = yield call(seurBuscar, action.payload)
    if (seurBuscarObj.ok) {
      yield put({
        type: actions.SEUR_BUSCAR_SUCCEEDED,
        payload: seurBuscarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Seur')
      yield put({
        type: actions.SEUR_BUSCAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Seur')
    yield all([
      put({
        type: actions.SEUR_BUSCAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SEUR_SEUR_BUSCAR(action) {
  try {
    const seurObj = yield call(seur, action.payload)
    if (seurObj.ok) {
      yield put({
        type: actions.SEUR_SEUR_BUSCAR_SUCCEEDED,
        payload: seurObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar Seur')
      yield put({
        type: actions.SEUR_SEUR_BUSCAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar Seur')
    yield all([
      put({
        type: actions.SEUR_SEUR_BUSCAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* CAMBIAR_ESTADO_MENSAJERIA(action) {
  try {
    const albaranesIdsObj = yield call(cambiarEstadoMensajeria, action.payload)
    if (albaranesIdsObj.ok) {
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SUCCEEDED,
        payload: albaranesIdsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
    yield all([
      put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* CAMBIAR_ESTADO_MENSAJERIA_SEUR(action) {
  try {
    const albaranesIdsObj = yield call(cambiarEstadoMensajeria, action.payload)
    if (albaranesIdsObj.ok) {
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_SUCCEEDED,
        payload: albaranesIdsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
    yield all([
      put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS(action) {
  try {
    const albaranesIdsObj = yield call(cambiarEstadoMensajeria, action.payload)
    if (albaranesIdsObj.ok) {
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_SUCCEEDED,
        payload: albaranesIdsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
      yield put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al Modificar Estados Mensajeria')
    yield all([
      put({
        type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_DHLS(action) {
  try {
    const dhlsObj = yield call(updateDhls, action.payload)
    if (dhlsObj.ok) {
      putMessage(messageType.SUCCESS, 'Dhls guardados correctamente')
      yield put({
        type: actions.DHLS_UPDATE_SUCCEEDED,
        payload: dhlsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar Dhls')
      yield put({
        type: actions.DHLS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar Dhls')
    yield all([
      put({
        type: actions.DHLS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_MRWSCLICK(action) {
  try {
    const mrwsObj = yield call(updateMrws, action.payload)
    if (mrwsObj.ok) {
      putMessage(messageType.SUCCESS, 'Mrws guardados correctamente')
      yield put({
        type: actions.MRWCLICK_UPDATE_SUCCEEDED,
        payload: mrwsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar Mrws')
      yield put({
        type: actions.MRWCLICK_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar Mrws')
    yield all([
      put({
        type: actions.MRWCLICK_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_SEURS(action) {
  try {
    const seursObj = yield call(updateSeurs, action.payload)
    if (seursObj.ok) {
      putMessage(messageType.SUCCESS, 'Seurs guardados correctamente')
      yield put({
        type: actions.SEURS_UPDATE_SUCCEEDED,
        payload: seursObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar Seurs')
      yield put({
        type: actions.SEURS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar Seurs')
    yield all([
      put({
        type: actions.SEURS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CORREOS_EXPRESS(action) {
  try {
    const correosExpressObj = yield call(updateCorreosExpress, action.payload)
    if (correosExpressObj.ok) {
      putMessage(messageType.SUCCESS, 'Correos Express guardados correctamente')
      yield put({
        type: actions.CORREOS_EXPRESS_UPDATE_SUCCEEDED,
        payload: correosExpressObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRANSMITIR_DHLS(action) {
  try {
    const dhlsObj = yield call(transmitirDhls, action.payload)
    if (dhlsObj.ok) {
      putMessage(messageType.SUCCESS, 'Solicitud para transmitir Dhls generada correctamente')
      yield put({
        type: actions.DHLS_TRANSMITIR_SUCCEEDED,
        payload: dhlsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Dhls')
      yield put({
        type: actions.DHLS_TRANSMITIR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Dhls')
    yield all([
      put({
        type: actions.DHLS_TRANSMITIR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRANSMITIR_SEURS(action) {
  try {
    const dhlsObj = yield call(transmitirSeurs, action.payload)
    if (dhlsObj.ok) {
      putMessage(messageType.SUCCESS, 'Solicitud para transmitir Seurs generada correctamente')
      yield put({
        type: actions.SEURS_TRANSMITIR_SUCCEEDED,
        payload: dhlsObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Seurs')
      yield put({
        type: actions.SEURS_TRANSMITIR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Seurs')
    yield all([
      put({
        type: actions.SEURS_TRANSMITIR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRANSMITIR_MRWSCLICK(action) {
  try {
    const mrwsClickObj = yield call(transmitirMrwsClick, action.payload)
    if (mrwsClickObj.ok) {
      putMessage(messageType.SUCCESS, 'Solicitud para transmitir Mrw generada correctamente')
      yield put({
        type: actions.MRWCLICK_TRANSMITIR_SUCCEEDED,
        payload: mrwsClickObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Mrw')
      yield put({
        type: actions.MRWCLICK_TRANSMITIR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Mrw')
    yield all([
      put({
        type: actions.MRWCLICK_TRANSMITIR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRANSMITIR_CORREOS_EXPRESS(action) {
  try {
    const correosExpressObj = yield call(transmitirCorreosExpress, action.payload)
    if (correosExpressObj.ok) {
      putMessage(
        messageType.SUCCESS,
        'Solicitud para transmitir Correos Express generada correctamente',
      )
      yield put({
        type: actions.CORREOS_EXPRESS_TRANSMITIR_SUCCEEDED,
        payload: correosExpressObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Correos Express')
      yield put({
        type: actions.CORREOS_EXPRESS_TRANSMITIR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear solicitud para transmitir Correos Express')
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_TRANSMITIR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_OBSERVACION(action) {
  try {
    const observacionObj = yield call(insertObservacion, action.payload)
    if (observacionObj.ok) {
      putMessage(messageType.SUCCESS, 'Observacion creada correctamente')
      yield put({
        type: actions.OBSERVACION_INSERT_SUCCEEDED,
        payload: observacionObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Observacio')
      yield put({
        type: actions.OBSERVACION_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Observacion')
    yield all([
      put({
        type: actions.OBSERVACION_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_OBSERVACION(action) {
  try {
    const observacionObj = yield call(modificarObservacion, action.payload)
    if (observacionObj.ok) {
      putMessage(messageType.SUCCESS, 'Observacion modificada correctamente')
      const returnObj = {
        id: action.payload.id,
        descripcion: getIdiomas().reduce((acc, idioma) => {
          acc[idioma.idiomaColumnField] = action.payload[`descripcion${idioma.idiomaColumnField}`]
          return acc
        }, {}),
      }
      yield put({
        type: actions.OBSERVACION_UPDATE_SUCCEEDED,
        payload: returnObj,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Observacion')
      yield put({
        type: actions.OBSERVACION_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Observacion')
    yield all([
      put({
        type: actions.OBSERVACION_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_OBSERVACION(action) {
  try {
    const observacionObj = yield call(deleteObservacion, action.payload)
    if (observacionObj.ok) {
      putMessage(messageType.SUCCESS, 'Observacion borrada correctamente')
      yield put({
        type: actions.OBSERVACION_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar Observacion')
      yield put({
        type: actions.OBSERVACION_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar Observacion')
    yield all([
      put({
        type: actions.OBSERVACION_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ESTADO_BULTO(action) {
  try {
    const estadoBultoObj = yield call(insertEstadoBulto, action.payload)
    if (estadoBultoObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado Bulto creado correctamente')
      yield put({
        type: actions.ESTADOS_BULTOS_INSERT_SUCCEEDED,
        payload: estadoBultoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Estado Bulto')
      yield put({
        type: actions.ESTADOS_BULTOS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Estado Bulto')
    yield all([
      put({
        type: actions.ESTADOS_BULTOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ESTADO_BULTO(action) {
  try {
    const estadoBultoObj = yield call(modificarEstadobulto, action.payload)
    if (estadoBultoObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado Bulto modificado correctamente')
      yield put({
        type: actions.ESTADOS_BULTOS_UPDATE_SUCCEEDED,
        payload: estadoBultoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Estado Bulto')
      yield put({
        type: actions.ESTADOS_BULTOS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Estado Bulto')
    yield all([
      put({
        type: actions.ESTADOS_BULTOS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ESTADO_BULTO(action) {
  try {
    const estadoBultoObj = yield call(deleteEstadoBulto, action.payload)
    if (estadoBultoObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado Bulto borrado correctamente')
      yield put({
        type: actions.ESTADOS_BULTOS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar Estado Bulto')
      yield put({
        type: actions.ESTADOS_BULTOS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar Estado Bulto')
    yield all([
      put({
        type: actions.ESTADOS_BULTOS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTADOS_BULTOS() {
  try {
    const estadosBultosData = yield call(getEstadosBultos)
    if (estadosBultosData.ok) {
      yield put({
        type: actions.ESTADOS_BULTOS_LOAD_SUCCEEDED,
        payload: estadosBultosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Estados Bultos')
      put({
        type: actions.ESTADOS_BULTOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTADOS_BULTOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANDEJAS_TODAS() {
  try {
    const bandejasTodasData = yield call(getBandejasTodas)
    if (bandejasTodasData.ok) {
      yield put({
        type: actions.TODAS_BANDEJAS_LOAD_SUCCEEDED,
        payload: bandejasTodasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bandejas Todas')
      put({
        type: actions.TODAS_BANDEJAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TODAS_BANDEJAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANDEJA(action) {
  try {
    const bandeja = yield call(getBandejaById, action.payload.id)
    if (bandeja.ok) {
      yield put({
        type: actions.BANDEJA_LOAD_SUCCEEDED,
        payload: bandeja.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bandeja')
      put({
        type: actions.BANDEJA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANDEJA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_VACIAR_BANDEJAS_TODAS(action) {
  try {
    const bandejaObj = yield call(vaciarBandejaTodas, action.payload)
    if (bandejaObj.ok) {
      putMessage(messageType.SUCCESS, 'Bandeja vaciada correctamente')
      yield put({
        type: actions.TODAS_BANDEJAS_VACIAR_SUCCEEDED,
        payload: bandejaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al vaciar Bandeja')
      yield put({
        type: actions.TODAS_BANDEJAS_VACIAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al vaciar Bandeja')
    yield all([
      put({
        type: actions.TODAS_BANDEJAS_VACIAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* VACIAR_BANDEJA(action) {
  try {
    const bandejaObj = yield call(vaciarBandejaTodas, { cesta: action.payload })
    if (bandejaObj.ok) {
      putMessage(messageType.SUCCESS, 'Bandeja vaciada correctamente')
      yield put({
        type: actions.BANDEJA_VACIAR_SUCCEEDED,
        payload: bandejaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al vaciar Bandeja')
      yield put({
        type: actions.BANDEJA_VACIAR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al vaciar Bandeja')
    yield all([
      put({
        type: actions.BANDEJA_VACIAR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANDEJAS() {
  try {
    const bandejasData = yield call(getBandejas)
    if (bandejasData.ok) {
      yield put({
        type: actions.BANDEJAS_LOAD_SUCCEEDED,
        payload: bandejasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bandejas')
      put({
        type: actions.BANDEJAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANDEJAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANDEJAS_LOG() {
  try {
    const bandejasData = yield call(getBandejasLog)
    if (bandejasData.ok) {
      yield put({
        type: actions.BANDEJAS_LOG_LOAD_SUCCEEDED,
        payload: bandejasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bandejas Log')
      put({
        type: actions.BANDEJAS_LOG_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANDEJAS_LOG_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* TERMINAR_BANDEJA(action) {
  try {
    const bandejaObj = yield call(terminarBandeja, action.payload)
    if (bandejaObj.ok) {
      putMessage(messageType.SUCCESS, 'Bandeja modificada correctamente')
      yield put({
        type: actions.BANDEJA_TERMINADA_SUCCEEDED,
        payload: bandejaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Bandeja')
      yield put({
        type: actions.BANDEJA_TERMINADA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Bandeja')
    yield all([
      put({
        type: actions.BANDEJA_TERMINADA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTANTERIAS() {
  try {
    const estanteriasData = yield call(getEstanterias)
    if (estanteriasData.ok) {
      yield put({
        type: actions.ESTANTERIAS_LOAD_SUCCEEDED,
        payload: estanteriasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Estanterias')
      put({
        type: actions.ESTANTERIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTANTERIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTANTES_LLENOS() {
  try {
    const estantesLlenosData = yield call(getEstantesLlenos)
    if (estantesLlenosData.ok) {
      yield put({
        type: actions.ESTANTES_LLENOS_LOAD_SUCCEEDED,
        payload: estantesLlenosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Estantes llenos')
      put({
        type: actions.ESTANTES_LLENOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTANTES_LLENOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ESTANTERIA(action) {
  try {
    const estanteriaObj = yield call(modificarEstanteria, action.payload)
    if (estanteriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Estanteria insertada correctamente')
      yield put({
        type: actions.ESTANTERIA_INSERT_SUCCEEDED,
        payload: estanteriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al insertar Estanteria')
      yield put({
        type: actions.ESTANTERIA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al insertar Estanteria')
    yield all([
      put({
        type: actions.ESTANTERIA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ESTANTERIA(action) {
  try {
    const estanteriaObj = yield call(modificarEstanteria, action.payload)
    if (estanteriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Estanteria modificada correctamente')
      yield put({
        type: actions.ESTANTERIA_UPDATE_SUCCEEDED,
        payload: estanteriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Estanteria')
      yield put({
        type: actions.ESTANTERIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Estanteria')
    yield all([
      put({
        type: actions.ESTANTERIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ESTANTERIA(action) {
  try {
    const estanteriaObj = yield call(deleteEstanteria, action.payload)
    if (estanteriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Estanteria borrada correctamente')
      yield put({
        type: actions.ESTANTERIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar Estanteria')
      yield put({
        type: actions.ESTANTERIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar Estanteria')
    yield all([
      put({
        type: actions.ESTANTERIA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CODIGO_BARRAS_ESTANTERIA(action) {
  try {
    const codigosBarrasObj = yield call(getCodigoBarrasEstanteria, action.payload)
    if (codigosBarrasObj.ok) {
      yield put({
        type: actions.CODIGO_BARRAS_ESTANTERIA_LOAD_SUCCEEDED,
        payload: codigosBarrasObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Código de Barras')
      yield put({
        type: actions.CODIGO_BARRAS_ESTANTERIA_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Código de Barras')
    yield all([
      put({
        type: actions.CODIGO_BARRAS_ESTANTERIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTANTE_VENTA(action) {
  try {
    const estante = yield call(getEstanteriaVenta, action.payload)
    if (estante.ok && estante.data) {
      yield put({
        type: actions.ESTANTE_VENTA_LOAD_SUCCEEDED,
        payload: estante.data,
      })
    } else {
      putMessage(messageType.ERROR, 'No se encontro el pedido')
      yield put({
        type: actions.ESTANTE_VENTA_LOAD_FILED,
      })
    }
  } catch (e) {
    console.error(e.message)
    putMessage(messageType.ERROR, 'Error al cargar el pedido')
    yield all([
      put({
        type: actions.ESTANTE_VENTA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_BANDEJA(action) {
  try {
    const response = yield call(setVentaBandeja, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_VENTA_BANDEJA_SUCCEEDED,
        payload: response.data,
      })
      if (response.data?.estante) {
        yield put({
          type: actions.REMOVE_VENTA_ESTANTE_REQUESTED,
          payload: response.data,
        })
      }
    } else {
      if (action.payload?.onError) {
        action.payload.onError()
      }
      putDialog(messageType.ERROR, 'La fecha del pedido no es valida')
      yield put({
        type: actions.SET_VENTA_BANDEJA_FILED,
      })
    }
  } catch (e) {
    if (action.payload?.onError) {
      action.payload.onError()
    }
    putMessage(messageType.ERROR, 'La fecha del pedido no es valida')
    yield all([
      put({
        type: actions.SET_VENTA_BANDEJA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* REMOVE_VENTA_ESTANTE(action) {
  try {
    console.log('REMOVE_VENTA_ESTANTE action.payload', action.payload)
    const response = yield call(removeVentaEstante, action.payload)
    if (response.ok) {
      if (action.payload.successMessage)
        putMessage(messageType.SUCCESS, action.payload.successMessage)
      yield put({
        type: actions.REMOVE_VENTA_ESTANTE_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el estante')
      yield put({
        type: actions.REMOVE_VENTA_ESTANTE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el estante')
    yield all([
      put({
        type: actions.REMOVE_VENTA_ESTANTE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_VENTA_BANDEJA(action) {
  try {
    const response = yield call(setVentaBandeja, { id: action.id, bandeja: null })
    if (response.ok) {
      yield put({
        type: actions.DELETE_VENTA_BANDEJA_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la venta de la bandeja')
      put({
        type: actions.DELETE_VENTA_BANDEJA_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DELETE_VENTA_BANDEJA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* REMOVE_VENTA_BANDEJA(action) {
  yield put({
    type: actions.REMOVE_VENTA_BANDEJA_SUCCEEDED,
    payload: action.id,
  })
}

export function* REMOVE_ALL_VENTA_BANDEJA(action) {
  yield put({
    type: actions.REMOVE_ALL_VENTA_BANDEJA_SUCCEEDED,
    payload: action.id,
  })
}

export function* GET_CORREOS_EXPRESS(action) {
  try {
    const response = yield call(getCorreosExpress, action.payload)
    if (response.ok) {
      yield put({
        type: actions.CORREOS_EXPRESS_LOAD_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar correos express')
      put({
        type: actions.CORREOS_EXPRESS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CORREOS_EXPRESS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_OBSERVACIONES_BULTO(action) {
  try {
    const response = yield call(setObservacionesBulto, action.payload)
    if (response.ok) {
      putMessage(messageType.SUCCESS, 'Observaciones actualizadas correctamente.')
      yield put({
        type: actions.SET_OBSERVACIONES_BULTO_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar las observaciones.')
      yield put({
        type: actions.SET_VENTA_BANDEJA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al actualizar las observaciones: (${e.message})`)
    yield all([
      put({
        type: actions.SET_VENTA_BANDEJA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_BULTOS_CHECK(action) {
  try {
    const response = yield call(setBultosCheckBulto, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_BULTOS_CHECK_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar el bulto')
      yield put({
        type: actions.SET_BULTOS_CHECK_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al actualizar el bulto: (${e.message})`)
    yield all([
      put({
        type: actions.SET_BULTOS_CHECK_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_FINALIZAR_IMPRIMIR(action) {
  try {
    const response = yield call(setVentaFinalizarImprimir, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_VENTA_FINALIZAR_IMPRIMIR_SUCCEEDED,
        payload: { ...action.payload, modificacionVentaList: response.data },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar la venta')
      yield put({
        type: actions.SET_VENTA_FINALIZAR_IMPRIMIR_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al actualizar la venta: (${e.message})`)
    yield all([
      put({
        type: actions.SET_VENTA_FINALIZAR_IMPRIMIR_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ORDEN_ESTANTERIA(action) {
  try {
    const response = yield call(getOrdenEstanteria, action.usuarioId)
    if (response.ok) {
      yield put({
        type: actions.GET_ORDEN_ESTANTERIA_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar el orden de la estanteria')
      put({
        type: actions.GET_ORDEN_ESTANTERIA_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_ORDEN_ESTANTERIA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ORDEN_ESTANTERIA(action) {
  try {
    const response = yield call(setOrdenEstanteria, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_ORDEN_ESTANTERIA_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar el orden')
      yield put({
        type: actions.SET_ORDEN_ESTANTERIA_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al guardar el orden: (${e.message})`)
    yield all([
      put({
        type: actions.SET_ORDEN_ESTANTERIA_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTANTE_ALEATORIO(action) {
  try {
    const response = yield call(getEstanteAleatorio, action.usuarioId)
    if (response.ok) {
      yield put({
        type: actions.GET_ESTANTE_ALEATORIO_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al asignar estante')
      put({
        type: actions.GET_ESTANTE_ALEATORIO_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al asignar estante: (${e.message})`)
    yield all([
      put({
        type: actions.GET_ESTANTE_ALEATORIO_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* ADD_LOG_ITEM_VENTA_SEPARADO(action) {
  try {
    const response = yield call(setVentaItemSeparado, action.payload)
    if (response.ok) {
      yield put({
        type: actions.ADD_LOG_VENTA_ITEM_SEPARADO_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al añadir log separado')
      yield put({
        type: actions.ADD_LOG_VENTA_ITEM_SEPARADO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al añadir log separado: (${e.message})`)
    yield all([
      put({
        type: actions.ADD_LOG_VENTA_ITEM_SEPARADO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_ESTANTERIA(action) {
  try {
    const response = yield call(setVentaEstanteria, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_VENTA_ESTANTERIA_UPDATE_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al añadir la venta a la estanteria')
      yield put({
        type: actions.SET_VENTA_ESTANTERIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al añadir la venta a la estanteria: (${e.message})`)
    yield all([
      put({
        type: actions.SET_VENTA_ESTANTERIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_OBSERVACION_CIERRE_VENTA(action) {
  try {
    const response = yield call(setObservacionCierreVenta, action.payload)
    if (response.ok) {
      putMessage(messageType.SUCCESS, 'Guardado correctamente')
      yield put({
        type: actions.OBSERVACION_CIERRE_VENTA_INSERT_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al añadir las observaciones de cierre')
      yield put({
        type: actions.OBSERVACION_CIERRE_VENTA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al añadir las observaciones de cierre: (${e.message})`)
    yield all([
      put({
        type: actions.OBSERVACION_CIERRE_VENTA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* ADD_LOG_ITEM_VENTA_VERIFICADO(action) {
  try {
    const response = yield call(setVentaItemVerificado, action.payload)
    if (response.ok) {
      yield put({
        type: actions.ADD_ITEM_VENTA_VERIFICADO_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al añadir log verificado')
      yield put({
        type: actions.ADD_ITEM_VENTA_VERIFICADO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al añadir log verificado: (${e.message})`)
    yield all([
      put({
        type: actions.ADD_ITEM_VENTA_VERIFICADO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_AGRUPADAS(action) {
  try {
    const ventasData = yield call(getVentasAgrupadas, action.ventaId)
    if (ventasData.ok) {
      yield put({
        type: actions.GET_VENTAS_AGRUPADAS_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas agrupadas')
      put({
        type: actions.GET_VENTAS_AGRUPADAS_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_VENTAS_AGRUPADAS_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_BANDEJA_PROPUESTA(action) {
  try {
    const ventasData = yield call(setBandejaPropuesta, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.SET_BANDEJA_PROPUESTA_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar bandeja proopuesta')
      put({
        type: actions.SET_BANDEJA_PROPUESTA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.SET_BANDEJA_PROPUESTA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MODIFICACIONES_VENTA(action) {
  try {
    const ventasData = yield call(getModificacionesVenta, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.GET_MODIFICACIONES_VENTA_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar modificaciones venta')
      put({
        type: actions.GET_MODIFICACIONES_VENTA_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_MODIFICACIONES_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* ADD_VENTA_LOAD(action) {
  try {
    if (action.ventas) {
      yield put({
        type: actions.ADD_VENTA_LOAD_REQUESTED,
        ventas: action.ventas,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ventas')
      put({
        type: actions.ADD_VENTA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ADD_VENTA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_AMAZON(action) {
  try {
    const ventasData = yield call(getVentasFilterAmazonFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_AMAZON_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar venta Amazon')
      put({
        type: actions.VENTAS_FILTER_AMAZON_LOAD_FAILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_AMAZON_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VENTAS_FILTER_NUESTROS_NOCTURNO(action) {
  try {
    const ventasData = yield call(getVentasFilterNocturnosFromAggregator, action.payload)
    if (ventasData.ok) {
      yield put({
        type: actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar nocturnos nuestros')
      put({
        type: actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_FAILED,
      })
    }
  } catch (e) {
    showVentasFilterError(e)
    yield all([
      put({
        type: actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ESTADO_VENTA(action) {
  try {
    const setEstado = yield call(setEstadoVenta, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Estado cambiado correctamente')
      yield put({
        type: actions.SET_ESTADO_VENTA_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el estado')
      yield put({
        type: actions.SET_ESTADO_VENTA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el estado')
    yield all([
      put({
        type: actions.SET_ESTADO_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ESTADO_BULTO_VENTA(action) {
  try {
    const result = yield call(setEstadoBultoVenta, action.payload)
    if (result.ok) {
      putMessage(messageType.SUCCESS, 'Estado Bulto cambiado correctamente')
      yield put({
        type: actions.SET_ESTADO_BULTO_VENTA_SUCCEEDED,
        payload: { ...result.data, id: action.payload.id, estadoBultoId: action.payload.estadoBultoId },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el estado bulto')
      yield put({
        type: actions.SET_ESTADO_BULTO_VENTA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el estado bulto')
    yield all([
      put({
        type: actions.SET_ESTADO_BULTO_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_OBSERVACIONES_BULTO_LISTA(action) {
  try {
    const response = yield call(setObservacionesBulto, action.payload)
    if (response.ok) {
      yield put({
        type: actions.SET_OBSERVACIONES_BULTO_LISTA_SUCCEEDED,
        payload: { id: action.payload.id, observacionesBultos: action.payload.observacionesBulto },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al actualizar las observaciones.')
      yield put({ type: actions.SET_OBSERVACIONES_BULTO_LISTA_FAILED })
    }
  } catch (e) {
    putMessage(messageType.ERROR, `Error al actualizar las observaciones: (${e.message})`)
    yield put({ type: actions.SET_OBSERVACIONES_BULTO_LISTA_FAILED, error: e.message })
  }
}

export function* SET_ESTADO_VENTA_MASIVO(action) {
  try {
    const setEstado = yield call(setEstadoVentaMasivo, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Estado cambiado correctamente')
      yield put({
        type: actions.SET_ESTADO_VENTA_MASIVO_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el estado')
      yield put({
        type: actions.SET_ESTADO_VENTA_MASIVO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el estado')
    yield all([
      put({
        type: actions.SET_ESTADO_VENTA_MASIVO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ESTADO_MENSAJERIA_VENTA_MASIVO(action) {
  try {
    const setEstado = yield call(setEstadoMensajeriaVentaMasivo, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Estado de mensajeria cambiado correctamente')
      yield put({
        type: actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el estado de mensajeria')
      yield put({
        type: actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el estado de mensajeria')
    yield all([
      put({
        type: actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PEDIDOS_MENSAJERO_VENTA(action) {
  try {
    const ventasData = yield call(getPedidosMensajeros, action.payload, true)
    if (ventasData.ok) {
      yield put({
        type: actions.GET_PEDIDOS_MENSAJERO_VENTA_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ruta mensajero')
      yield put({
        type: actions.GET_PEDIDOS_MENSAJERO_VENTA_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_PEDIDOS_MENSAJERO_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PEDIDOS_SIN_MENSAJERO_VENTA(action) {
  try {
    const ventasData = yield call(getPedidosMensajeros, action.payload, false)
    if (ventasData.ok) {
      yield put({
        type: actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_SUCCEEDED,
        payload: ventasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar pedidos')
      yield put({
        type: actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ORDEN_PEDIDOS_MENSAJERO(action) {
  try {
    const setEstado = yield call(setOrdenMensajeroVentas, action.payload)
    if (setEstado.ok) {
      yield put({
        type: actions.SET_ORDEN_PEDIDOS_MENSAJERO_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el orden')
      yield put({
        type: actions.SET_ORDEN_PEDIDOS_MENSAJERO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el orden')
    yield all([
      put({
        type: actions.SET_ORDEN_PEDIDOS_MENSAJERO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_DATOS_ENTREGA_VENTA(action) {
  try {
    const setEstado = yield call(setDatosEntregaVenta, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Datos de entrega cambiados correctamente')
      yield put({
        type: actions.SET_DATOS_ENTREGA_VENTA_SUCCEEDED,
        payload: setEstado.data,
      })
      action.alTerminar?.(true)
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar los datos de entrega')
      yield put({
        type: actions.SET_DATOS_ENTREGA_VENTA_FAILED,
      })
      action.alTerminar?.(false)
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar los datos de entrega')
    yield all([
      put({
        type: actions.SET_DATOS_ENTREGA_VENTA_FAILED,
        error: e.message,
      }),
    ])
    action.alTerminar?.(false)
  }
}

export function* SET_TRANSPORTISTA_VENTA(action) {
  try {
    const setEstado = yield call(setTransportistaVenta, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Transportista cambiado correctamente')
      yield put({
        type: actions.SET_TRANSPORTISTA_VENTA_SUCCEEDED,
        payload: setEstado.data,
      })
      yield put({
        type: actions.GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED,
        payload: { fechaEntrega: action.payload.fechaEntrega },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cambiar el transportista')
      yield put({
        type: actions.SET_TRANSPORTISTA_VENTA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cambiar el transportista')
    yield all([
      put({
        type: actions.SET_TRANSPORTISTA_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_TRANSPORTISTA_VENTA(action) {
  try {
    const setEstado = yield call(deleteTransportistaVenta, action.payload)
    if (setEstado.ok) {
      putMessage(messageType.SUCCESS, 'Transportista quitado correctamente')
      yield put({
        type: actions.SET_TRANSPORTISTA_VENTA_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al quitar el transportista')
      yield put({
        type: actions.SET_TRANSPORTISTA_VENTA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al quitar el transportista')
    yield all([
      put({
        type: actions.SET_TRANSPORTISTA_VENTA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_VENTA_MENSAJERO_SEPARADO(action) {
  try {
    const setEstado = yield call(setMensajeroSeparado, action.payload)
    if (setEstado.ok) {
      yield put({
        type: actions.SET_VENTA_MENSAJERO_SEPARADO_SUCCEEDED,
        payload: setEstado.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al separar bulto')
      yield put({
        type: actions.SET_VENTA_MENSAJERO_SEPARADO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al separar bulto')
    yield all([
      put({
        type: actions.SET_VENTA_MENSAJERO_SEPARADO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_AMAZON_FILTER(action) {
  try {
    const amazonData = yield call(getAmazonFilter, action.payload, false)
    if (amazonData.ok) {
      yield put({
        type: actions.AMAZON_FILTER_SUCCEEDED,
        payload: amazonData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar pedidos de Amazon')
      yield put({
        type: actions.AMAZON_FILTER_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar pedidos de Amazon')
    yield all([
      put({
        type: actions.AMAZON_FILTER_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_AMAZON_TRANSMITIR(action) {
  try {
    const amazonData = yield call(setAmazonTransmitir, action.payload, false)
    if (amazonData.ok) {
      putMessage(messageType.SUCCESS, 'Realizando la transmisión de pedidos de Amazon')
      yield put({
        type: actions.AMAZON_TRANSMITIR_SUCCEEDED,
        payload: amazonData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al transmitir pedidos de Amazon')
      yield put({
        type: actions.AMAZON_TRANSMITIR_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al transmitir pedidos de Amazon')
    yield all([
      put({
        type: actions.AMAZON_TRANSMITIR_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* SET_ESTANTERIA_PRESELECCIONADA(action) {
  try {
    console.log('SET_ESTANTERIA_PRESELECCIONADA action.payload:', action.payload)
    yield put({
      type: actions.SET_ESTANTERIA_PRESELECCIONADA_SUCCEEDED,
      payload: action.payload,
    })
    
  } catch (e) {
    putMessage(messageType.ERROR, `Error al preseleccionar estanteria: (${e.message})`)
    yield all([
      put({
        type: actions.SET_ESTANTERIA_PRESELECCIONADA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.VENTAS_LOAD_REQUESTED, GET_VENTAS),
    takeEvery(actions.VENTAS_FILTER_LOAD_REQUESTED, GET_VENTAS_FILTER),
    takeEvery(
      actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_REQUESTED,
      GET_VENTAS_FILTER_MENSAJEROS_NUESTROS,
    ),
    takeEvery(
      actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_REQUESTED,
      GET_VENTAS_FILTER_GRABADOS_SIN_PERSO_NUESTROS,
    ),
    takeEvery(
      actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_REQUESTED,
      GET_VENTAS_FILTER_BORDADOS_SIN_PERSO_NUESTROS,
    ),
    takeEvery(actions.VENTAS_FILTER_RESCATE_LOAD_REQUESTED, GET_VENTAS_FILTER_RESCATE),
    takeEvery(
      actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_REQUESTED,
      GET_VENTAS_FILTER_PERSONALIZADOS,
    ),
    takeEvery(
      actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_REQUESTED,
      GET_VENTAS_FILTER_PERSONALIZADOS_TOTAL,
    ),
    takeEvery(
      actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_REQUESTED,
      GET_VENTAS_FILTER_PERSONALIZADOS_PREPARADOS,
    ),
    takeEvery(
      actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_REQUESTED,
      GET_VENTAS_FILTER_PERSONALIZADOS_FABRICADOS,
    ),
    takeEvery(actions.VENTAS_FILTER_EN_SOBRE_LOAD_REQUESTED, GET_VENTAS_FILTER_EN_SOBRE),
    takeEvery(actions.VENTAS_FILTER_TODOS_LOAD_REQUESTED, GET_VENTAS_FILTER_TODOS),
    takeEvery(actions.VENTAS_FILTER_NOCTURNOS_LOAD_REQUESTED, GET_VENTAS_FILTER_NOCTURNOS),
    takeEvery(actions.VENTAS_FILTER_DIURNOS_LOAD_REQUESTED, GET_VENTAS_FILTER_DIURNOS),
    takeEvery(actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_REQUESTED, GET_VENTAS_FILTER_FIGURAS_LEGO),
    takeEvery(actions.VENTAS_FILTER_ECOMMERCE_LOAD_REQUESTED, GET_VENTAS_FILTER_ECOMMERCE),
    takeEvery(
      actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_REQUESTED,
      GET_VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO,
    ),
    takeEvery(actions.VENTAS_FILTER_LOCAL_LOAD_REQUESTED, GET_VENTAS_FILTER_LOCAL),
    takeEvery(actions.VENTAS_FILTER_DIGITAL_LOAD_REQUESTED, GET_VENTAS_FILTER_DIGITALES),
    takeEvery(actions.VENTAS_FILTER_EMPLEADOS_LOAD_REQUESTED, GET_VENTAS_FILTER_EMPLEADOS),
    takeEvery(actions.VENTAS_FILTER_EKOMI_LOAD_REQUESTED, GET_VENTAS_FILTER_EKOMI),
    takeEvery(
      actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_REQUESTED,
      GET_VENTAS_FILTER_FUERA_DE_ESPANA,
    ),
    takeEvery(
      actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_REQUESTED,
      GET_VENTAS_FILTER_FUERA_DE_ESPANA_SEUR,
    ),
    takeEvery(
      actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_REQUESTED,
      GET_VENTAS_FILTER_FUERA_DE_ESPANA_DHL,
    ),
    takeEvery(actions.VENTAS_FILTER_DHL_LOAD_REQUESTED, GET_VENTAS_FILTER_DHL),
    takeEvery(
      actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_REQUESTED,
      GET_VENTAS_FILTER_CHOCOMENSAJE,
    ),
    takeEvery(actions.OBSERVACIONES_VENTA_LOAD_REQUESTED, GET_OBSERVACIONES_VENTAS),
    takeEvery(
      actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_REQUESTED,
      GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS,
    ),
    takeEvery(actions.MAIL_OBSERVACION_TEMPLATE_INSERT_REQUESTED, INSERT_MAIL_OBSERVACIONES),
    takeEvery(actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_REQUESTED, UPDATE_MAIL_OBSERVACIONES),
    takeEvery(actions.DELETE_MAIL_OBSERVACION_TEMPLATE_REQUESTED, DELETE_MAIL_OBSERVACIONES),
    takeEvery(actions.VENTA_BYID_LOAD_REQUESTED, GET_VENTA_BY_ID),
    takeEvery(actions.VENTA_UPDATE_REQUESTED, UPDATE_VENTA),
    takeEvery(
      actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_REQUESTED,
      INSERT_OBSERVACION_SEGUIMIENTO_VENTA,
    ),
    takeEvery(actions.ABONO_DELETE_REQUESTED, DELETE_ABONO_VENTA),
    takeEvery(actions.CUPON_DELETE_REQUESTED, DELETE_CUPON_VENTA),
    takeEvery(actions.CUPONES_LOAD_REQUESTED, GET_CUPONES_NO_USADOS),
    takeEvery(actions.ADD_CUPONES_REQUESTED, ADD_CUPONES_VENTA),
    takeEvery(actions.CANCELAR_VENTA_REQUESTED, CANCELAR_VENTA),
    takeEvery(
      actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_REQUESTED,
      INSERT_OBSERVACION_PREPARACION_VENTA,
    ),
    takeEvery(actions.ENVIAR_MAIL_OBSERVACION_VENTA_REQUESTED, ENVIAR_MAIL_OBSERVACION_VENTA),
    takeEvery(
      actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_REQUESTED,
      ENVIAR_MAIL_OBSERVACION_VENTA_DONE,
    ),
    takeEvery(actions.BORRAR_MENSAJERO_REQUESTED, BORRAR_MENSAJERO),
    takeEvery(actions.BORRAR_BANDEJA_REQUESTED, BORRAR_BANDEJA),
    takeEvery(actions.MARCAR_PAGADO_REQUESTED, MARCAR_PAGADO),
    takeEvery(actions.INSERTAR_NUEVA_DEVOLUCION_REQUESTED, INSERTAR_NUEVA_DEVOLUCION),
    takeEvery(actions.ANULAR_DEVOLUCION_REQUESTED, ANULAR_DEVOLUCION),
    takeEvery(actions.SET_VENTA_LETRA_REQUESTED, SET_VENTA_LETRA),
    takeEvery(actions.SET_VENTA_VIP_REQUESTED, SET_VENTA_VIP),
    takeEvery(actions.INSERT_ABONO_REQUESTED, INSERTAR_NUEVO_ABONO),
    takeEvery(actions.TRASPASAR_VENTA_REQUESTED, TRASPASAR_VENTA),
    takeEvery(actions.DHL_BUSCAR_REQUESTED, DHL_BUSCAR),
    takeEvery(actions.DHL_DHL_BUSCAR_REQUESTED, DHL_DHL_BUSCAR),
    takeEvery(actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_REQUESTED, CAMBIAR_ESTADO_MENSAJERIA),
    takeEvery(
      actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_REQUESTED,
      CAMBIAR_ESTADO_MENSAJERIA_SEUR,
    ),
    takeEvery(
      actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_REQUESTED,
      CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS,
    ),
    takeEvery(actions.DHLS_UPDATE_REQUESTED, UPDATE_DHLS),
    takeEvery(actions.DHLS_TRANSMITIR_REQUESTED, TRANSMITIR_DHLS),
    takeEvery(actions.SEURS_TRANSMITIR_REQUESTED, TRANSMITIR_SEURS),
    takeEvery(actions.MRWCLICK_TRANSMITIR_REQUESTED, TRANSMITIR_MRWSCLICK),
    takeEvery(actions.SEUR_BUSCAR_REQUESTED, SEUR_BUSCAR),
    takeEvery(actions.SEUR_SEUR_BUSCAR_REQUESTED, SEUR_SEUR_BUSCAR),
    takeEvery(actions.SEURS_UPDATE_REQUESTED, UPDATE_SEURS),
    takeEvery(actions.CORREOS_EXPRESS_BUSCAR_REQUESTED, CORREOS_EXPRESS_BUSCAR),
    takeEvery(actions.CORREOS_EXPRESS_ECOMMERCE_REQUESTED, CORREOS_EXPRESS_ECOMMERCE),
    takeEvery(actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_REQUESTED, CORREOS_EXPRESS_ECOMMERCE_TRAMO),
    takeEvery(actions.CORREOS_EXPRESS_SOBRES_REQUESTED, CORREOS_EXPRESS_SOBRES),
    takeEvery(actions.CORREOS_EXPRESS_TRANSMITIR_REQUESTED, TRANSMITIR_CORREOS_EXPRESS),
    takeEvery(actions.CORREOS_EXPRESS_UPDATE_REQUESTED, UPDATE_CORREOS_EXPRESS),
    takeEvery(actions.MRWCLICK_BUSCAR_REQUESTED, MRWCLICK_BUSCAR),
    takeEvery(actions.MRWCLICK_DIURNOS_REQUESTED, MRWCLICK_DIURNOS),
    takeEvery(actions.MRWCLICK_NOCTURNOS_REQUESTED, MRWCLICK_NOCTURNOS),
    takeEvery(actions.MRWCLICK_ECOMMERCE_REQUESTED, MRWCLICK_ECOMMERCE),
    takeEvery(actions.MRWCLICK_ECOMMERCETH_REQUESTED, MRWCLICK_ECOMMERCE_TH),
    takeEvery(actions.MRWCLICK_SOBRE_REQUESTED, MRWCLICK_SOBRE),
    takeEvery(actions.MRWCLICK_UPDATE_REQUESTED, UPDATE_MRWSCLICK),
    takeEvery(actions.OBSERVACION_INSERT_REQUESTED, INSERT_OBSERVACION),
    takeEvery(actions.OBSERVACION_UPDATE_REQUESTED, UPDATE_OBSERVACION),
    takeEvery(actions.OBSERVACION_DELETE_REQUESTED, DELETE_OBSERVACION),
    takeEvery(actions.ESTADOS_BULTOS_INSERT_REQUESTED, INSERT_ESTADO_BULTO),
    takeEvery(actions.ESTADOS_BULTOS_UPDATE_REQUESTED, UPDATE_ESTADO_BULTO),
    takeEvery(actions.ESTADOS_BULTOS_DELETE_REQUESTED, DELETE_ESTADO_BULTO),
    takeEvery(actions.ESTADOS_BULTOS_LOAD_REQUESTED, GET_ESTADOS_BULTOS),
    takeEvery(actions.TODAS_BANDEJAS_LOAD_REQUESTED, GET_BANDEJAS_TODAS),
    takeEvery(actions.TODAS_BANDEJAS_VACIAR_REQUESTED, UPDATE_VACIAR_BANDEJAS_TODAS),
    takeEvery(actions.BANDEJAS_LOAD_REQUESTED, GET_BANDEJAS),
    takeEvery(actions.BANDEJA_LOAD_REQUESTED, GET_BANDEJA),
    takeEvery(actions.BANDEJA_TERMINAR_REQUESTED, TERMINAR_BANDEJA),
    takeEvery(actions.BANDEJAS_LOG_LOAD_REQUESTED, GET_BANDEJAS_LOG),
    takeEvery(actions.ESTANTERIAS_LOAD_REQUESTED, GET_ESTANTERIAS),
    takeEvery(actions.ESTANTERIA_INSERT_REQUESTED, INSERT_ESTANTERIA),
    takeEvery(actions.ESTANTERIA_UPDATE_REQUESTED, UPDATE_ESTANTERIA),
    takeEvery(actions.ESTANTERIA_DELETE_REQUESTED, DELETE_ESTANTERIA),
    takeEvery(actions.ESTANTES_LLENOS_LOAD_REQUESTED, GET_ESTANTES_LLENOS),
    takeEvery(actions.CODIGO_BARRAS_ESTANTERIA_LOAD_REQUESTED, GET_CODIGO_BARRAS_ESTANTERIA),
    takeEvery(actions.ESTANTE_VENTA_LOAD_REQUESTED, GET_ESTANTE_VENTA),
    takeEvery(actions.SET_VENTA_BANDEJA_REQUESTED, SET_VENTA_BANDEJA),
    takeEvery(actions.DELETE_VENTA_BANDEJA_REQUESTED, DELETE_VENTA_BANDEJA),
    takeEvery(actions.REMOVE_VENTA_BANDEJA_REQUESTED, REMOVE_VENTA_BANDEJA),
    takeEvery(actions.REMOVE_ALL_VENTA_BANDEJA_REQUESTED, REMOVE_ALL_VENTA_BANDEJA),
    takeEvery(actions.BANDEJA_VACIAR_REQUESTED, VACIAR_BANDEJA),
    takeEvery(actions.CORREOS_EXPRESS_LOAD_REQUESTED, GET_CORREOS_EXPRESS),
    takeEvery(actions.REMOVE_VENTA_ESTANTE_REQUESTED, REMOVE_VENTA_ESTANTE),
    takeEvery(actions.SET_OBSERVACIONES_BULTO_REQUESTED, SET_OBSERVACIONES_BULTO),
    takeEvery(actions.SET_OBSERVACIONES_BULTO_LISTA_REQUESTED, SET_OBSERVACIONES_BULTO_LISTA),
    takeEvery(actions.SET_VENTA_FINALIZAR_IMPRIMIR_REQUESTED, SET_VENTA_FINALIZAR_IMPRIMIR),
    takeEvery(actions.SET_ORDEN_ESTANTERIA_REQUESTED, SET_ORDEN_ESTANTERIA),
    takeEvery(actions.GET_ORDEN_ESTANTERIA_REQUESTED, GET_ORDEN_ESTANTERIA),
    takeEvery(actions.GET_ESTANTE_ALEATORIO_REQUESTED, GET_ESTANTE_ALEATORIO),
    takeEvery(actions.ADD_LOG_VENTA_ITEM_SEPARADO_REQUESTED, ADD_LOG_ITEM_VENTA_SEPARADO),
    // takeLatest y no takeEvery: el estante es un único campo de la venta, así que
    // ante dispatches solapados la última escritura es la buena. Evita que una
    // respuesta vieja pise el estado con un estante ya obsoleto.
    takeLatest(actions.SET_VENTA_ESTANTERIA_UPDATE_REQUESTED, SET_VENTA_ESTANTERIA),
    takeEvery(actions.OBSERVACION_CIERRE_VENTA_INSERT_REQUESTED, SET_OBSERVACION_CIERRE_VENTA),
    takeEvery(actions.ADD_ITEM_VENTA_VERIFICADO_REQUESTED, ADD_LOG_ITEM_VENTA_VERIFICADO),
    takeEvery(actions.GET_VENTAS_AGRUPADAS_REQUESTED, GET_VENTAS_AGRUPADAS),
    takeEvery(actions.SET_BANDEJA_PROPUESTA_LOAD_REQUESTED, SET_BANDEJA_PROPUESTA),
    takeEvery(actions.GET_MODIFICACIONES_VENTA_REQUESTED, GET_MODIFICACIONES_VENTA),
    // takeLatest y no takeEvery: los cuatro botones Nocturnos comparten esta accion y
    // solo interesa el resultado del ultimo clic. No cancela la consulta ya lanzada en
    // SQL, pero evita acumular respuestas y descarta las peticiones anteriores.
    takeLatest(
      actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_REQUESTED,
      GET_VENTAS_FILTER_NOCTURNOS_CORREOS,
    ),
    takeEvery(actions.ADD_VENTA_LOAD_REQUESTED, ADD_VENTA_LOAD),
    takeEvery(actions.VENTAS_FILTER_AMAZON_LOAD_REQUESTED, GET_VENTAS_FILTER_AMAZON),
    takeEvery(
      actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_REQUESTED,
      GET_VENTAS_FILTER_NUESTROS_NOCTURNO,
    ),
    takeEvery(actions.SET_BULTOS_CHECK_REQUESTED, SET_BULTOS_CHECK),
    takeEvery(actions.SET_ESTADO_VENTA_REQUESTED, SET_ESTADO_VENTA),
    takeEvery(actions.SET_ESTADO_BULTO_VENTA_REQUESTED, SET_ESTADO_BULTO_VENTA),
    takeEvery(actions.VENTAS_RELOAD_VENTA_REQUESTED, VENTAS_RELOAD_VENTA),
    takeEvery(actions.SET_ESTADO_VENTA_MASIVO_REQUESTED, SET_ESTADO_VENTA_MASIVO),
    takeEvery(
      actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_REQUESTED,
      SET_ESTADO_MENSAJERIA_VENTA_MASIVO,
    ),
    takeEvery(actions.GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED, GET_PEDIDOS_MENSAJERO_VENTA),
    takeEvery(actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_REQUESTED, GET_PEDIDOS_SIN_MENSAJERO_VENTA),
    takeEvery(actions.SET_ORDEN_PEDIDOS_MENSAJERO_REQUESTED, SET_ORDEN_PEDIDOS_MENSAJERO),
    takeEvery(actions.SET_DATOS_ENTREGA_VENTA_REQUESTED, SET_DATOS_ENTREGA_VENTA),
    takeEvery(actions.SET_TRANSPORTISTA_VENTA_REQUESTED, SET_TRANSPORTISTA_VENTA),
    takeEvery(actions.DELETE_TRANSPORTISTA_VENTA_REQUESTED, DELETE_TRANSPORTISTA_VENTA),
    takeEvery(actions.SET_VENTA_MENSAJERO_SEPARADO_REQUESTED, SET_VENTA_MENSAJERO_SEPARADO),
    takeEvery(actions.AMAZON_FILTER_REQUESTED, GET_AMAZON_FILTER),
    takeEvery(actions.AMAZON_TRANSMITIR_REQUESTED, SET_AMAZON_TRANSMITIR),
    takeEvery(actions.VENTA_BYID_CONTROLDISENO_LOAD_REQUESTED, GET_VENTA_BYID_CONTROLDISENO),
    takeEvery(actions.SET_ESTANTERIA_PRESELECCIONADA_REQUESTED, SET_ESTANTERIA_PRESELECCIONADA),
    takeEvery(actions.VENTAS_TILDAR_FILTER_LOAD_REQUESTED, GET_VENTAS_TILDAR_FILTER),
  ])
}
